import { useStyles } from '@team-griffin/stylr';
import { getBodyColor } from 'presentation/utils/colorway';
import { gu2px, useTheme, Colorway, cssTheme } from '@uds/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
import { modifier } from '@ux/style-utils';
import { Alignment } from 'domain/constants/alignment';
import { smallprint } from '@ux/type-size';
import { Layout } from 'domain/constants/layout';
import { useBreakpoints } from '@ux/responsive';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';
import { css } from 'linaria';

export const getClassNames = () => {
  return {
    precursor: css`
      margin-bottom: ${cssTheme.gu1};
    `,
    subtitle: css`
      margin-top: ${cssTheme.gu2};
    `,
    cta: css`
      margin-top: ${cssTheme.gu1};
    `,
  };
};
export default ({ colorway, layout, isMinSm }: { colorway: Colorway; layout: Layout; isMinSm: Boolean }) => {
  const { theme } = useTheme();
  const { spacing } = theme;
  const alignment = findResponsiveItem(useBreakpoints(), [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);

  return useStyles(
    {
      default: {
        root: {
          position: 'relative',
        },
        ctas: {
          display: 'flex',
          flexDirection: 'column',
          marginTop: gu2px(2, spacing),
          overflow: 'hidden',
        },
        footerText: {
          marginTop: gu2px(1, spacing),
          ...smallprint(),
          color: getBodyColor(theme, colorway),
          opacity: 0.9,
        },
      },

      isMinSm: {
        ctas: {
          flexDirection: 'row',
          ...cssSides('margin', Side.X, 0 - gu2px(0.5, spacing)),
        },
        cta: {
          marginBottom: 0,
          ...cssSides('margin', Side.X, gu2px(0.5, spacing)),
        },
      },

      [modifier('alignment', Alignment.CENTER)]: {
        root: {
          textAlign: 'center',
        },
        footerText: {
          textAlign: 'center',
        },
        ctas: {
          justifyContent: 'center',
        },
      },
    },
    [{ isMinSm }, { alignment }],
  );
};
